module.exports = __webpack_public_path__ + "c7db4567635b47f4826bce71d023654a.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/gamerules/rules_nl.pdf
// module id = 412
// module chunks = 1